import React from 'react';
import { BannerWrapper } from '@fiverr-private/gig_listings';
import { JoinProRewardsProgramBanner, JoinProRewardsProgramBannerProps } from './JoinProRewardsProgramBanner';

export const JoinProRewardsProgramBannerWithWrapper = ({ tier }: JoinProRewardsProgramBannerProps) =>
    BannerWrapper(<JoinProRewardsProgramBanner tier={tier} />)({
        className: 'join-pro-rewards-program-banner-listings',
        bannerRow: 3,
    });
